import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, exhaustMap, map, of } from "rxjs";
import { EmployeeReportService } from "src/app/shared/services/employee-report.service";
import { EmployeeReportActions } from "./employee-report.actions";
import { NotifyService } from "src/app/shared/services/notify.service";

@Injectable()

export class EmployeeReportEffects {

    constructor(
        private service: EmployeeReportService,
        private action$: Actions,
        private notify: NotifyService 
    ) { }

    loadEmployeeReport$ = createEffect(() =>
        this.action$.pipe(
            ofType(EmployeeReportActions.loadEmployeeReport),
            exhaustMap(() =>
                this.service
                    .get()
                    .pipe(
                        map((res) => EmployeeReportActions.loadEmployeeReportSuccess({ employee_report: res })),
                        catchError((error) => {
                            this.notify.emitError('Falha ao carregar registros')
                            return of(error.error['hydra:description'])
                        })
                    )
            )
        )
    )

}